import * as Yup from "yup";
import { Organization, Maybe } from "../../generated/graphql";

const getSchema = () => {
    return Yup.object().shape({
        name: Yup.string().required().default(""),
        tin: Yup.string().required().default(""),
        address: Yup.string().required().default(""),
        zipCode: Yup.string().required().default(""),
    })
}

export const getInitialValues = (schema: Yup.ObjectSchema<any>) => {
    return schema.cast({});
}

const organizationFormInit = (record?: Maybe<Organization>) => {
    const schema = getSchema()
    const initial = record ? record : getInitialValues(schema)
    return { schema, initial }
}

export default organizationFormInit
